import React from "react";

interface ValueChipProps {
  label: string;
  variant?: 'blue' | 'amber' | 'green' | 'red';
}

// variant: "blue" | "amber" | "green" | "red"
const ValueChip = ({ label, variant = "blue" }: ValueChipProps) => (
  <span className={`valueChip valueChip--${variant}`}>{label}</span>
);

export default ValueChip;
